import React from 'react';

interface OtherReasonTextareaProps {
  value: string;
  onChange: (value: string) => void;
}

const OtherReasonTextarea: React.FC<OtherReasonTextareaProps> = ({
  value,
  onChange,
}) => {
  return (
    <div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <div className="govuk-body">
          When ‘Not appropriate (other reason)’ please explain why
        </div>
        <textarea
          className="govuk-textarea"
          id="other-reason"
          name="otherReason"
          rows={5}
          value={value}
          onChange={event => onChange(event.target.value)}
        />
      </div>
    </div>
  );
};

export default OtherReasonTextarea;
